import React from 'react';
import { motion } from 'framer-motion';
export function BuiltDifferent() {
  const features = [{
    icon: '🌍',
    title: 'No Learning Curve',
    desc: 'Just talk. MR figures out the rest.'
  }, {
    icon: '🗣️',
    title: 'Fully Multilingual',
    desc: 'Any language. Mid-conversation. No setup.'
  }, {
    icon: '🗺️',
    title: 'Live Business Mind Map',
    desc: 'See your entire business in one living, breathing view.'
  }];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/20 to-transparent" data-id="element-96" />

      <section className="py-16 px-6 bg-white" data-id="element-97">
        <div className="inner-container" data-id="element-98">
          <div className="text-center mb-10" data-id="element-99">
            <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-100">
              Built Different
            </span>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-101">
            {features.map((feat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-gradient-to-r from-purple/10 to-teal/10 border border-gray-200 rounded-full py-4 px-8 flex items-center gap-4 shadow-sm hover:shadow-md hover:border-purple/30 transition-all" data-id="element-102">
                <span className="text-2xl" data-id="element-103">{feat.icon}</span>
                <div data-id="element-104">
                  <h3 className="font-poppins font-semibold text-sm text-gray-900" data-id="element-105">
                    {feat.title}
                  </h3>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-106">{feat.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-teal/20 to-transparent" data-id="element-107" />
    </>;
}